// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"79":"c1f2a858","177":"5ad11f25","361":"9924fe39","384":"ed86b127","474":"6f90d6c3","877":"c167c764"}[chunkId] + ".css";
};